import { useState, useEffect } from 'react';

function useFullscreenState() {
  const [fullscreenSupported, setFullscreenSupported] = useState(false);
  const [fullscreenEnabled, setFullscreenEnabled] = useState(
  // @ts-expect-error bad typings
  (document.fullscreenElement ?? document.webkitFullscreenElement) != null);
  useEffect(() => {
    setFullscreenSupported(
    // @ts-expect-error bad typings
    document.fullscreenEnabled ?? document.webkitFullscreenEnabled);
    function updateFullscreenState() {
      setFullscreenEnabled(
      // @ts-expect-error bad typings
      (document.fullscreenElement ?? document.webkitFullscreenElement) != null);
    }
    document.documentElement.addEventListener("fullscreenchange", updateFullscreenState);
    document.documentElement.addEventListener("webkitfullscreenchange", updateFullscreenState);
    return () => {
      document.documentElement.removeEventListener("fullscreenchange", updateFullscreenState);
      document.documentElement.removeEventListener("webkitfullscreenchange", updateFullscreenState);
    };
  }, []);
  return {
    fullscreenSupported,
    fullscreenEnabled
  };
}

export { useFullscreenState };
//# sourceMappingURL=fullscreen.state.js.map
